module.exports = __webpack_public_path__ + "img/diners.f29e0694.png";